import { isTopWindowAccessible } from './isTopWindowAccessible';
const getTopWindow = () => (isTopWindowAccessible() ? window.top : window);
export { getTopWindow };
